import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import colors from "styles/colors";
import { StyledHotdogHeaderComponent } from "./hotdog-header-component.scss";
class HotdogHeaderComponent extends PureComponent {
    render() {
        const { className, backgroundColor, containerHeight, containerMinHeight, hotdogColor, children } = this.props;
        return /*#__PURE__*/ _jsxs(StyledHotdogHeaderComponent, {
            className: `hotdog-header-component ${className}`,
            style: {
                height: containerHeight,
                minHeight: containerMinHeight,
                backgroundColor: colors[backgroundColor]
            },
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "hotdog",
                    style: {
                        backgroundColor: colors[hotdogColor]
                    }
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "children-wrapper",
                    children: children
                })
            ]
        });
    }
}
export { HotdogHeaderComponent as default };
HotdogHeaderComponent.defaultProps = {
    containerHeight: "48vh"
};
